import React from 'react';
import { About, Footer, Header, Skills, Testimonial, Work } from './container';
import { Navbar } from './components';
import NavigationDots from './components/NavigationDots';
import SocialMedia from './components/SocialMedia';

import './App.scss';
// import AllSkills from './container/AllSkills/AllSkills';

const App = () => {
  
  return (
    <div className='app'>

       
        <Navbar />
        <div style={{position: 'fixed', zIndex: '100', left: '0', bottom: '10%'}}>
        <SocialMedia />
        </div>
        <div style={{position: 'fixed', zIndex: '100', right: '10px', bottom: '40%'}}>
        <NavigationDots />
        </div>
        <Header />
        <About />
        <Work />
        <Skills />
        {/* <Testimonial /> */}
        {/* <AllSkills /> */}
        <Footer />
    </div>
    
  )
}

export default App;